import cogoToast from 'cogo-toast';

const defaultOptions = {
  position: 'top-center',
  hideAfter: 3,
};

export const showToast = (message, type = 'success', options = {}) => {
  const mergedOptions = { ...defaultOptions, ...options };
  
  switch (type) {
    case 'success':
      return cogoToast.success(message, mergedOptions);
    case 'info':
      return cogoToast.info(message, mergedOptions);
    case 'loading':
      return cogoToast.loading(message, mergedOptions);
    case 'warn':
      return cogoToast.warn(message, mergedOptions);
    case 'error':
      return cogoToast.error(message, mergedOptions);
    default:
      return cogoToast.success(message, mergedOptions);
  }
};

// showToast('Custom positioned toast', 'info', { position: 'bottom-right', hideAfter: 5 });